import spr1 from "../assets/sports/5.jpeg";
import spr2 from "../assets/sports/2026_FIFA_World_Cup.png";
import spr3 from "../assets/sports/afcon25.webp";
import spr4 from "../assets/sports/championsleague02.jpg";
import spr5 from "../assets/sports/eredivisieposter.jpeg";
import spr6 from "../assets/sports/f1poster.jpg";
import spr7 from "../assets/sports/f1poster2.jpeg";
import spr8 from "../assets/sports/ligue1d.jpg";
import spr9 from "../assets/sports/motogp.jpg";
import spr10 from "../assets/sports/nascarsports.jpg";
import spr11 from "../assets/sports/seriaitaly.webp";
import spr12 from "../assets/sports/tennis.jpg";
import spr13 from "../assets/sports/ufc.jpg";

import leag1 from "../assets/league/Ligue_1.png";
import leag2 from "../assets/league/Ligue_2.png";
import leag3 from "../assets/league/ucl.png";
import leag4 from "../assets/league/Premier_League.png";
import leag5 from "../assets/league/LaLiga.png";
import leag6 from "../assets/league/Serie_A.png";
import leag7 from "../assets/league/Bundesliga.png";
import leag8 from "../assets/league/Jupiler_Pro_League.png";
import leag9 from "../assets/league/UEFA_Europa_League.png";
import leag10 from "../assets/league/rsl.png";
import leag11 from "../assets/league/UFC.png";
import leag12 from "../assets/league/F1.png";

import SectionHeading from '../components/SectionHeading';
import Marquee from '../components/Marquee';
import Reveal from '../components/Reveal';
import { useLanguage } from '../i18n/LanguageContext';
import { sportsContent } from '../i18n/content/sports';

export default function Sports() {
  const { lang } = useLanguage();
  const c = sportsContent[lang];
  const sports = [
    { id: 1, image: spr1, title: "Poster 1" },
    { id: 2, image: spr2, title: "World Cup 2026" },
    { id: 3, image: spr3, title: "AFCON 2025" },
    { id: 4, image: spr4, title: "Champions League" },
    { id: 5, image: spr5, title: "Eredivisie" },
    { id: 6, image: spr6, title: "F1" },
    { id: 7, image: spr7, title: "F1 Poster 2" },
    { id: 8, image: spr8, title: "Ligue 1" },
    { id: 9, image: spr9, title: "MotoGP" },
    { id: 10, image: spr10, title: "NASCAR" },
    { id: 11, image: spr11, title: "Serie A" },
    { id: 12, image: spr12, title: "Tennis" },
    { id: 13, image: spr13, title: "UFC" },
  ];

  const leaguesByName = {
    "Ligue 1": { image: leag1, name: "Ligue 1" },
    "Ligue 2": { image: leag2, name: "Ligue 2" },
    "F1": { image: leag12, name: "F1" },
    "UEFA Champions League": { image: leag3, name: "UEFA Champions League" },
    "Premier League": { image: leag4, name: "Premier League" },
    "La Liga": { image: leag5, name: "La Liga" },
    "Serie A": { image: leag6, name: "Serie A" },
    "Bundesliga": { image: leag7, name: "Bundesliga" },
    "Jupiler Pro League": { image: leag8, name: "Jupiler Pro League" },
    "UEFA Europa League": { image: leag9, name: "UEFA Europa League" },
    "Saudi League": { image: leag10, name: "Saudi League" },
    "UFC": { image: leag11, name: "UFC" },
  };
  const leagues = c.leagueOrder.map((name, i) => ({ id: i + 1, ...leaguesByName[name] }));

  return (
    <section className="section2" id="sports" style={{backgroundColor: 'var(--bg-color)'}}>
      <div className="main-content">
        <Reveal className="mb-10">
          <SectionHeading eyebrow={c.eyebrow} title={c.title} align="center" />
        </Reveal>

        {/* Carousel des sports — défilement continu */}
        <Reveal delay={100} className="mb-10">
          <Marquee
            items={sports}
            duration={42}
            renderItem={(item) => (
              <div className="group relative w-[150px] sm:w-[180px] md:w-[200px] lg:w-[220px] aspect-[2/3] rounded-card-md shadow-sm overflow-hidden border border-line">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
              </div>
            )}
          />
        </Reveal>

        {/* Ligues disponibles — défilement continu */}
        <Reveal delay={150} className="mb-8">
          <Marquee
            items={leagues}
            direction="right"
            duration={34}
            renderItem={(lig) => {
              const isTightCrop = lig.name === "UFC" || lig.name === "F1";
              return (
                <div className="bg-white rounded-card-md border border-line px-6 py-4 shadow-sm w-40 sm:w-44 flex items-center justify-center h-16 md:h-20">
                  <img
                    src={lig.image}
                    alt={lig.name}
                    loading="lazy"
                    className={`max-w-full max-h-full object-contain opacity-90 ${isTightCrop ? "scale-75" : ""}`}
                  />
                </div>
              );
            }}
          />
        </Reveal>
      </div>
    </section>
  );
}
